export type BootstrapAuthenticatedSessionDeps = {
  saveToken: (forceRefresh?: boolean) => Promise<void>;
  pushTokenOnResume: () => Promise<void>;
  authenticate: () => Promise<void>;
  /** Downloads a missing project list (and the permissions). */
  downloadProjectListWhenMissing: () => void;
  requestResyncAfterResume: () => void;
  markLogoutFlowCompleted: () => void;
};

export async function bootstrapAuthenticatedSession(
  deps: BootstrapAuthenticatedSessionDeps,
  options?: { forceTokenRefresh?: boolean }
): Promise<void> {
  try {
    await deps.saveToken(options?.forceTokenRefresh ?? false);
    await deps.pushTokenOnResume();
    await deps.authenticate();
    deps.downloadProjectListWhenMissing();
    deps.requestResyncAfterResume();
  } finally {
    deps.markLogoutFlowCompleted();
  }
}
